import { render } from "./BaseLogo.vue?vue&type=template&id=35f8f848&scoped=true&ts=true"
import script from "./BaseLogo.vue?vue&type=script&lang=ts"
export * from "./BaseLogo.vue?vue&type=script&lang=ts"

import "./BaseLogo.vue?vue&type=style&index=0&id=35f8f848&lang=scss&scoped=true"
import "./BaseLogo.vue?vue&type=style&index=1&id=35f8f848&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35f8f848"]])

export default __exports__